import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import { WithTheme } from './../../../setup/index'
import media from '../../../common/MediaQueries'

const IconTextStyled = styled.div`
  display: flex;
  align-items: center;
`

const IconTextMediaStyled = styled.div`
  width: 3.125rem;
  margin-right: 1.875rem;
  @media ${media.phone} {
    margin-right: 2.6875rem;
  }
`

const IconTextContentStyled = styled(Text)<WithTheme>`
  font-size: 1.0625rem;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.secondary};
`

export { IconTextStyled, IconTextMediaStyled, IconTextContentStyled }
